import espaguete from "../assets/images/ingredients/espaguete.png";
import tomate from "../assets/images/ingredients/tomate-cereja.png";

const ingredients = [
  {
    id: 1,
    name: "Macarrão espaguete",
    image: espaguete,
    description: "1 Pacote | 500g",
  },
  {
    id: 2,
    name: "Tomate cereja",
    image: tomate,
    description: "Picado | 3 unidades",
  },
];

export default ingredients;
